module.exports = __webpack_public_path__ + "img/stadium.1faf7d23.svg";